import { createContext, useContext } from 'react';
import { ToastOptions } from '../hooks/useCustomToast';

type ToastContextValue = {
    showToast: (opts: ToastOptions) => void;
};

export const ToastContext = createContext<ToastContextValue>({
    showToast: () => {
        throw new Error('showToast must be used inside <ToastProvider />');
    },
});

export const useToast = () => useContext(ToastContext);